export default __webpack_public_path__ + "static/media/product7.4dcc113d.webp";